// extracted by mini-css-extract-plugin
export default {"page":"home_page__BGEFI","right":"home_right__RsFjg","left":"home_left__-21ce"};